import React from "react";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import defaultImage from "../../../assets/images/default.jpg";

const ServiceProviderDocumentsDialog = ({ open, onClose, providerData }) => {
  const documents = [
    { label: "Logo / Headshot", url: providerData?.logo, icon: "fa-image" },
    { label: "Government ID", url: providerData?.govId, icon: "fa-id-card" },
    { label: "Address Proof", url: providerData?.addressProof, icon: "fa-map-marker-alt" },
  ];

  const handleImageError = (e) => {
    e.target.onerror = null;
    e.target.src = defaultImage;
  };

  const openInNewTab = (url) => {
    if (url) window.open(url, "_blank");
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        style: {
          backgroundColor: "#ffffff",
          color: "#333",
          borderRadius: "12px",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
        },
      }}
    >
      <DialogTitle
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "1px solid #e5e7eb",
          padding: "16px 24px",
          backgroundColor: "#fff",
        }}
      >
        <div>
          <span style={{ fontSize: "18px", fontWeight: "600", color: "#1f2937" }}>
            Service Provider Documents
          </span>
          <p style={{ fontSize: "14px", color: "#6b7280", margin: "4px 0 0 0" }}>
            {providerData?.firstName} {providerData?.lastName} — {providerData?.providerName}
          </p>
          <p style={{ fontSize: "13px", color: "#6b7280", margin: "2px 0 0 0" }}>
            Category: {providerData?.serviceCategory || "—"}
          </p>
          {providerData?.description && (
            <p style={{ fontSize: "13px", color: "#374151", margin: "8px 0 0 0", maxWidth: "560px" }}>
              {providerData.description}
            </p>
          )}
        </div>
        <IconButton onClick={onClose} style={{ color: "#6b7280" }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent style={{ padding: "24px", backgroundColor: "#f9fafb" }}>
        <div className="row">
          {documents.map((doc, index) => (
            <div key={index} className="col-md-4 mb-4">
              <div
                style={{
                  backgroundColor: "#ffffff",
                  borderRadius: "8px",
                  padding: "16px",
                  height: "100%",
                  border: "1px solid #e5e7eb",
                  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                }}
              >
                <div style={{ display: "flex", alignItems: "center", marginBottom: "12px" }}>
                  <i
                    className={`fas ${doc.icon}`}
                    style={{ fontSize: "18px", marginRight: "10px", color: "#D4A418" }}
                  ></i>
                  <span style={{ fontWeight: "600", color: "#1f2937" }}>{doc.label}</span>
                </div>
                {doc.url ? (
                  <div>
                    <img
                      src={doc.url}
                      alt={doc.label}
                      style={{
                        width: "100%",
                        height: "150px",
                        objectFit: "cover",
                        borderRadius: "6px",
                        cursor: "pointer",
                        marginBottom: "10px",
                        border: "1px solid #e5e7eb",
                      }}
                      onClick={() => openInNewTab(doc.url)}
                      onError={handleImageError}
                    />
                    <button
                      onClick={() => openInNewTab(doc.url)}
                      style={{
                        width: "100%",
                        padding: "8px",
                        backgroundColor: "#D4A418",
                        border: "none",
                        borderRadius: "6px",
                        color: "#000",
                        fontWeight: "500",
                        cursor: "pointer",
                      }}
                    >
                      Open full size
                    </button>
                  </div>
                ) : (
                  <div
                    style={{
                      height: "150px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#9ca3af",
                      fontStyle: "italic",
                      backgroundColor: "#f3f4f6",
                      borderRadius: "6px",
                    }}
                  >
                    Not uploaded
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ServiceProviderDocumentsDialog;
